import { c as _c } from "react/compiler-runtime";
import { Button, Form } from '@onefootprint/ui';
import { FormProvider, useForm } from 'react-hook-form';
import Section from '@/playbook-builder/components/section';
import SubSection from '@/playbook-builder/components/sub-section';
import type { BusinessDataNodeProps } from '@/playbook-builder/playbook-builder.types';
import type { ApplyEditMutation } from '../../../base-node';
import { collectsData } from '../../../identity-data-node/utils/data-collection-utils';
import type { FormBusinessData } from './business.types';
import createInfoPayload from './utils/create-info-payload';
type InformationSectionProps = {
  node: BusinessDataNodeProps;
  onDone: () => void;
  mutation: ApplyEditMutation;
};
const InformationSection = t0 => {
  const $ = _c(42);
  const {
    node,
    onDone,
    mutation
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] !== node.data) {
    const collects = collectsData(node.data);
    t7 = useForm;
    t1 = true;
    t2 = collects("business_address");
    t3 = collects("business_corporation_type");
    t4 = collects("business_phone_number");
    t5 = collects("business_tin");
    t6 = collects("business_website");
    $[0] = node.data;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4 || $[12] !== t5 || $[13] !== t6) {
    t8 = {
      defaultValues: {
        name: t1,
        address: t2,
        corporationType: t3,
        phone: t4,
        tin: t5,
        website: t6
      }
    };
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const formMethods = t7(t8);
  const {
    handleSubmit
  } = formMethods;
  let t9;
  if ($[15] !== mutation || $[16] !== node || $[17] !== onDone) {
    t9 = async formData => {
      ;
      try {
        mutation.mutateAsync({
          kind: "update_node",
          nodeData: createInfoPayload(node, formData),
          nodeId: node.id
        });
        onDone();
      } catch (t10) {
        const error = t10;
        console.error("Error updating playbook session:", error);
      }
    };
    $[15] = mutation;
    $[16] = node;
    $[17] = onDone;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  const handleFormSubmit = t9;
  let t10;
  if ($[19] !== handleFormSubmit || $[20] !== handleSubmit) {
    t10 = handleSubmit(handleFormSubmit);
    $[19] = handleFormSubmit;
    $[20] = handleSubmit;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <SubSection title="Business name"><Form.Checkbox name="name" label="Request users to provide their business's name" disabled={true} /></SubSection>;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <SubSection title="Business address"><Form.Checkbox name="address" label="Request users to provide their business's address" /></SubSection>;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <SubSection title="TIN (EIN)"><Form.Checkbox name="tin" label="Request users to provide their business's Tax Identification Number" /></SubSection>;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <SubSection title="Legal entity type"><Form.Checkbox name="corporationType" label="Request users to provide their business's legal entity type" /></SubSection>;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <SubSection title="Website"><Form.Checkbox name="website" label="Request users to provide their business's website" /></SubSection>;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <SubSection title="Phone number"><Form.Checkbox name="phone" label="Request users to provide their business's phone number" /></SubSection>;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== mutation.isPending) {
    t17 = <Button variant="primary" fullWidth={true} type="submit" loading={mutation.isPending}>Save</Button>;
    $[28] = mutation.isPending;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== mutation.isPending || $[31] !== onDone) {
    t18 = <Button variant="secondary" fullWidth={true} onClick={onDone} disabled={mutation.isPending}>Cancel</Button>;
    $[30] = mutation.isPending;
    $[31] = onDone;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] !== t17 || $[34] !== t18) {
    t19 = <Section title="Edit business information">{t11}{t12}{t13}{t14}{t15}{t16}<footer className="flex flex-col gap-2">{t17}{t18}</footer></Section>;
    $[33] = t17;
    $[34] = t18;
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  let t20;
  if ($[36] !== t10 || $[37] !== t19) {
    t20 = <form onSubmit={t10}>{t19}</form>;
    $[36] = t10;
    $[37] = t19;
    $[38] = t20;
  } else {
    t20 = $[38];
  }
  let t21;
  if ($[39] !== formMethods || $[40] !== t20) {
    t21 = <FormProvider {...formMethods}>{t20}</FormProvider>;
    $[39] = formMethods;
    $[40] = t20;
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  return t21;
};
export default InformationSection;